
import { useState, useEffect, useCallback } from "react";
import { useSession } from "@/hooks/useSession";
import { useFileCompletion } from "./useFileCompletion";
import { useProgressInitializer } from "./useProgressInitializer";
import { useCompletionMarker } from "./useCompletionMarker";

export function useTrainingProgress(resourceId?: string, fileId?: string) {
  const { session } = useSession();
  const [retryCount, setRetryCount] = useState(0);
  
  const { 
    isLoading, 
    isCompleted, 
    completedAt, 
    error, 
    isFirebaseError,
    checkCompletion 
  } = useFileCompletion(resourceId, fileId);
  
  const { 
    initializeTracking 
  } = useProgressInitializer(resourceId, fileId);
  
  const { 
    markAsCompleted,
    syncQuizProgress
  } = useCompletionMarker(resourceId, fileId);
  
  const retryOperation = useCallback(() => {
    setRetryCount(prev => prev + 1);
  }, []);
  
  useEffect(() => {
    if (resourceId && fileId && session?.user?.id) {
      // Initialize tracking for this file
      initializeTracking();
      
      // Then check completion status
      checkCompletion();
      
      // Then sync quiz progress if needed
      syncQuizProgress().then(synced => {
        if (synced) {
          // Re-check completion if we synced something
          checkCompletion();
        }
      });
    }
  }, [resourceId, fileId, session?.user?.id, checkCompletion, initializeTracking, syncQuizProgress, retryCount]);
  
  return {
    isLoading,
    isCompleted,
    completedAt,
    error,
    isFirebaseError,
    checkCompletion,
    markAsCompleted,
    retryOperation,
    initializeTracking
  };
}
